module.exports = "<div class=\"container-outer-box\">\n    <p>\n      testing works!\n    </p>\n    <div class=\"c100 p{{percentDone}} small\" *ngIf=\"percentDone>0\">\n        <span>{{percentDone}}%</span>\n        <div class=\"slice\">\n            <div class=\"bar\"></div>\n            <div class=\"fill\"></div>\n        </div>\n    </div>\n    <a (click)=\"getData()\">download</a>\n    </div>"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/testing/testing.component.html
// module id = ../../../../../src/app/home/testing/testing.component.html
// module chunks = common